import React from "react";

export default function NotFound() {
  return (
    <center>
      <div>
        <img src={require("./../../../images/sadface.svg")} />
        <h6 />
        <h6>404</h6>
        <h7>Page Not Found</h7>
      </div>
    </center>
  );
}
